{
  "_meta": {
    "asOf": "2025",
    "source": "Editorial choice of representative city per state — chosen as the largest city with the income-tax structure most residents experience, or 'none' if the state has no meaningful local income tax.",
    "schema": "defaultCity references an entry in local-overlays.json (or 'none')"
  },
  "AL": {"defaultCity": "birmingham_al"},
  "AK": {"defaultCity": "none"},
  "AZ": {"defaultCity": "none"},
  "AR": {"defaultCity": "none"},
  "CA": {"defaultCity": "none"},
  "CO": {"defaultCity": "none"},
  "CT": {"defaultCity": "none"},
  "DE": {"defaultCity": "wilmington_de"},
  "DC": {"defaultCity": "none"},
  "FL": {"defaultCity": "none"},
  "GA": {"defaultCity": "none"},
  "HI": {"defaultCity": "none"},
  "ID": {"defaultCity": "none"},
  "IL": {"defaultCity": "none"},
  "IN": {"defaultCity": "none"},
  "IA": {"defaultCity": "none"},
  "KS": {"defaultCity": "none"},
  "KY": {"defaultCity": "louisville_ky"},
  "LA": {"defaultCity": "none"},
  "ME": {"defaultCity": "none"},
  "MD": {"defaultCity": "none"},
  "MA": {"defaultCity": "none"},
  "MI": {"defaultCity": "detroit"},
  "MN": {"defaultCity": "none"},
  "MS": {"defaultCity": "none"},
  "MO": {"defaultCity": "kansas_city_mo"},
  "MT": {"defaultCity": "none"},
  "NE": {"defaultCity": "none"},
  "NV": {"defaultCity": "none"},
  "NH": {"defaultCity": "none"},
  "NJ": {"defaultCity": "none"},
  "NM": {"defaultCity": "none"},
  "NY": {"defaultCity": "nyc"},
  "NC": {"defaultCity": "none"},
  "ND": {"defaultCity": "none"},
  "OH": {"defaultCity": "columbus"},
  "OK": {"defaultCity": "none"},
  "OR": {"defaultCity": "portland_or"},
  "PA": {"defaultCity": "philadelphia"},
  "RI": {"defaultCity": "none"},
  "SC": {"defaultCity": "none"},
  "SD": {"defaultCity": "none"},
  "TN": {"defaultCity": "none"},
  "TX": {"defaultCity": "none"},
  "UT": {"defaultCity": "none"},
  "VT": {"defaultCity": "none"},
  "VA": {"defaultCity": "none"},
  "WA": {"defaultCity": "none"},
  "WV": {"defaultCity": "none"},
  "WI": {"defaultCity": "none"},
  "WY": {"defaultCity": "none"}
}
